import { render, staticRenderFns } from "./thematicFilter.vue?vue&type=template&id=72cbc920&scoped=true&lang=html"
import script from "./thematicFilter.vue?vue&type=script&lang=js"
export * from "./thematicFilter.vue?vue&type=script&lang=js"
import style0 from "./thematicFilter.vue?vue&type=style&index=0&id=72cbc920&prod&lang=css"
import style1 from "./thematicFilter.vue?vue&type=style&index=1&id=72cbc920&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cbc920",
  null
  
)

export default component.exports